module.exports = __webpack_public_path__ + "images/fa-pre-footer-projects.webp";